import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { CustomerListPage } from '@/features/customers'

export const Route = createFileRoute('/_authenticated/customers/')({
  component: () => (
    <RequirePermission permission='customers.read'>
      <CustomerListPage />
    </RequirePermission>
  ),
})
